import { IonItem, IonToggle } from "@ionic/react";
import { useSettingsContext } from '../../context';
import { useTranslation } from 'react-i18next';

export function ThemeSwitcher() {
	const { theme, saveTheme } = useSettingsContext();
	const { t } = useTranslation();

	function onToggle(event: CustomEvent) {
		saveTheme(event.detail.checked ? "dark" : "light");
	}

	return (
		<IonItem>
			{t("userSettings.themeSwitcherTitle")}
			<IonToggle
				checked={theme === "dark"}
				onIonChange={onToggle}
				style={{ marginLeft: "auto" }}
			></IonToggle>
		</IonItem>
	);
}
